import { render, staticRenderFns } from "./CustomGanttv2.vue?vue&type=template&id=5dffa83d&scoped=true&"
import script from "./CustomGanttv2.vue?vue&type=script&lang=js&"
export * from "./CustomGanttv2.vue?vue&type=script&lang=js&"
import style0 from "./CustomGanttv2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomGanttv2.vue?vue&type=style&index=1&id=5dffa83d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dffa83d",
  null
  
)

export default component.exports